import { Text } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(
    {
        wrap: {
            padding: 40,
            height: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            alignContent: 'center',
            '& > * + *': {
                marginTop: 16,
            },
        },
        list: {
            paddingLeft: 20,
        },
    },
    { classNamePrefix: 'embed-prevent-3rd-party' }
);

const EmbedPreventThirdPartyTrackingMessage = () => {
    const classnames = useStyles();
    const isIOSMobile =
        /(iPad)/i.test(navigator?.userAgent) || /(iPhone)/i.test(navigator?.userAgent);
    return (
        <div className={classnames.wrap}>
            <Text variant="t40">
                Access Session
                <br />
                Engagement Tools
            </Text>
            <Text variant="t71">
                To access session engagement tools, you may need to enable cross-site tracking in
                your browser settings:
                <ol className={classnames.list}>
                    {isIOSMobile ? (
                        <>
                            <li>Open Settings on your device</li>
                            <li>Open Safari tab</li>
                            <li>Go to the Privacy tab</li>
                            <li>{'Disable "Prevent cross-site tracking"'}</li>
                            <li>Go back to browser</li>
                            <li>Reload page</li>
                        </>
                    ) : (
                        <>
                            <li>Open Safari</li>
                            <li>Go to Preferences</li>
                            <li>Go to the Privacy tab</li>
                            <li>{'Disable "Prevent cross-site tracking"'}</li>
                            <li>Reload page</li>
                        </>
                    )}
                </ol>
            </Text>
        </div>
    );
};

export default EmbedPreventThirdPartyTrackingMessage;
